import { isDemo } from 'helpers/utility';

const externalConfig =
  typeof atsConfiguration !== 'undefined' ? atsConfiguration : {}; /* eslint-disable-line */
const {
  apiUrl,
  graphqlUrl,
  flexPaperUrl,
  converterUrl,
  flexPaperAssetsUrl,
  posloviBaseUrl,
  poslonautBaseUrl,
  oauthUrl,
  // sentryDsn,
  wwwHrlabUrl,
  socketHrlabUrl,
  calendlyScheduleUrl,
} = externalConfig;

const defaultConfig = {
  baseUrl: import.meta.env.VITE_APP_BASE_URL,
  apiUrl: apiUrl || import.meta.env.VITE_APP_API_URL,
  graphqlUrl: graphqlUrl || import.meta.env.VITE_APP_GRAPHQL_URL,
  flexPaperUrl: isDemo() ? '/' : flexPaperUrl || import.meta.env.VITE_APP_FLEXPAPER_URL,
  converterUrl: converterUrl || import.meta.env.VITE_APP_CONVERTER_URL,
  flexPaperAssetsUrl: flexPaperAssetsUrl || import.meta.env.VITE_APP_FLEXPAPER_ASSETS_URL,
  posloviBaseUrl: posloviBaseUrl || import.meta.env.VITE_APP_POSLOVI_BASE_URL,
  poslonautBaseUrl: poslonautBaseUrl || import.meta.env.VITE_APP_POSLONAUT_BASE_URL,
  oauthUrl: oauthUrl || import.meta.env.VITE_APP_OAUTH_URL,
  sentryDsn: 'https://2e4187c892794300ac99b0bb2b82fb7f@logerr.infostud.cloud/2',
  wwwHrlabUrl: wwwHrlabUrl || import.meta.env.VITE_APP_WWW_HRLAB_URL,
  socketHrlabUrl:
    socketHrlabUrl || import.meta.env.VITE_APP_SOCKET_HRLAB_URL || 'https://socket.hrlab.rs',
  // Empty in the demo: CalendlyScheduler renders nothing without a URL.
  calendlyScheduleUrl: isDemo()
    ? ''
    : calendlyScheduleUrl ||
      import.meta.env.VITE_APP_CALENDLY_SCHEDULE_URL ||
      'https://calendly.com/infostud-hrlab/proces-selekcije',
};

export default defaultConfig;

const siteConfig = {
  siteName: 'Theseus ATS',
  siteIcon: 'ion-flash',
  footerText: `Theseus ATS © ${new Date().getFullYear()}`,
};
const themeConfig = {
  topbar: 'themedefault',
  sidebar: 'themedefault',
  layout: 'themedefault',
  theme: 'atsFancy',
};
const language = 'serbian';
export { language, siteConfig, themeConfig };

export const smartSortEnabledByDefault = false;
